
export enum MultifactorAuthenticationMethod {
  EMAIL = 'email',
  AUTHENTICATOR_APP = 'authenticatorApp',
}
